class DeliverySaverAnalytics {
    constructor(analytics) {
        this.analytics = analytics;
    }

    push(deliveryPlus) {
        this.analytics.push({ data: deliveryPlus, type: this.analytics.mapperTypes.deliveryPlus });
    }
}

DeliverySaverAnalytics.$inject = ['AnalyticsService'];

module.exports = { DeliverySaverAnalytics };



// WEBPACK FOOTER //
// ./src/deliverysaver/delivery-saver-analytics.service.js